"use client";
import React, { useEffect, useState } from 'react';
import { useRouter, usePathname } from 'next/navigation';
import { scrollToTop, toCamelCase, getHashFromUrl, syncActiveCategory } from '@/app/utils/commonUtils';

interface NavigationBarProps {
    data: any;
}

const NavigationBar = (props: NavigationBarProps) => {

    const { navigationItems } = props.data;
    const router = useRouter();
    const pathname = usePathname();

    const [activeCategory, setActiveCategory] = useState('');
    const [topOffset, setTopOffset] = useState(56);

    useEffect(() => {
        const calculateTopOffset = () => {
            const header = document.querySelector('header');
            if (header) {
                const headerHeight = header.getBoundingClientRect().height;
                setTopOffset(headerHeight);
            }
        };

        calculateTopOffset();

        window.addEventListener('resize', calculateTopOffset);

        const header = document.querySelector('header');
        let resizeObserver: ResizeObserver | null = null;

        if (header) {
            resizeObserver = new ResizeObserver(() => {
                calculateTopOffset();
            });
            resizeObserver.observe(header);
        }

        return () => {
            window.removeEventListener('resize', calculateTopOffset);
            if (resizeObserver) {
                resizeObserver.disconnect();
            }
        };
    }, []);

    useEffect(() => {
        syncActiveCategory(pathname, setActiveCategory);
    }, [pathname]);

    useEffect(() => {
        const hashChangeHandler = () => {
            const hash = getHashFromUrl();
            if (hash) {
                setActiveCategory(hash);
            }
        }

        window.addEventListener('hashchange', hashChangeHandler);

        return () => {
            window.removeEventListener('hashchange', hashChangeHandler);
        }
    }, [])

    return <nav className={`flex items-center px-6 z-40 sticky w-full justify-center h-[40px]`} style={{ background: '#DDF1FD', top: `${topOffset}px` }}>
        <div className={`max-w-7xl mx-auto flex flex-nowrap items-center justify-center sm:gap-10 lg:gap-16 xl:gap-24 text-sm font-medium text-black w-full h-full`}>
            {navigationItems.map((navItem: any, index: number) => {
                const itemHash = toCamelCase(navItem.title);
                const isActive = activeCategory === itemHash;
                return (
                    <a 
                        key={navItem.title || index}
                        href={`/resources#${itemHash}`}
                        className="h-full flex items-center shrink-0"
                        onClick={(e) => {
                            e.preventDefault();
                            scrollToTop();

                            if (pathname === '/resources') {
                                window.location.hash = itemHash;
                            } else {
                                router.push(`/resources#${itemHash}`);
                            }
                        }}
                    >
                        <span
                            className={`px-6 capitalize whitespace-nowrap cursor-pointer h-full flex items-center
                                    ${isActive ? 'bg-[#032d60] text-white border-b-[3px] border-[#3AB5FC]' : ''}
                                `}
                        >
                            {navItem.title}
                        </span>
                    </a>
                );
            })}
        </div>
    </nav>

};

export default NavigationBar;